import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ArticleCard from '@/components/feature/ArticleCard';
import ScrollToTop from '@/components/feature/ScrollToTop';
import { categories } from '@/mocks/categories';
import { articles } from '@/mocks/articles';

export default function Home() {
  const featuredArticles = articles.slice(0, 4);
  const latestArticles = articles.slice(4);

  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '爱妻艺',
    url: 'https://mhowiub.cn',
    description: '爱妻艺——让爱有艺术，让妻子更幸福。专注于夫妻关系经营的艺术与智慧，提供最实用的婚姻幸福指南。',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://mhowiub.cn/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const organizationSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '爱妻艺',
    url: 'https://mhowiub.cn',
    description: '专注于夫妻关系经营的艺术与智慧，帮助每一位丈夫成为妻子心中最好的伴侣。',
    contactPoint: {
      '@type': 'ContactPoint',
      email: 'hello@mhowiub.cn',
      contactType: 'customer service',
    },
  };

  return (
    <>
      <ScrollToTop />
      <script type="application/ld+json">{JSON.stringify(websiteSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(organizationSchema)}</script>

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main>
          {/* Hero Section */}
          <section className="relative h-[600px] md:h-[680px] flex items-center justify-center overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=A%20warm%20romantic%20abstract%20artistic%20composition%20with%20soft%20rose%20and%20coral%20tones%2C%20gentle%20gradients%2C%20elegant%20flowing%20shapes%2C%20abstract%20hearts%20and%20petals%2C%20dreamy%20atmosphere%2C%20digital%20art%20style%2C%20soft%20focus%2C%20warm%20golden%20light%20accents&width=1600&height=900&seq=hero-bg-main&orientation=landscape"
              alt="爱妻艺"
              className="absolute inset-0 w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/40"></div>
            <div className="relative z-10 w-full px-4 md:px-6 text-center">
              <div className="max-w-3xl mx-auto">
                <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/15 backdrop-blur-sm mb-6">
                  <i className="ri-heart-fill text-primary-400 text-sm"></i>
                  <span className="text-white/90 text-sm font-medium">专注于夫妻关系经营的艺术与智慧</span>
                </div>
                <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
                  让爱有艺术
                  <br />
                  让妻子更幸福
                </h1>
                <p className="text-white/80 text-base md:text-lg mb-8 max-w-xl mx-auto leading-relaxed">
                  无论是浪漫仪式感、沟通技巧还是日常关爱，爱妻艺为您提供最实用的婚姻幸福指南，帮助每一位丈夫成为妻子心中最好的伴侣。
                </p>
                <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
                  <Link
                    to="/category/langman-yishi"
                    className="px-6 py-3 rounded-full bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer no-underline"
                  >
                    探索文章
                    <i className="ri-arrow-right-line ml-2"></i>
                  </Link>
                  <Link
                    to="/about"
                    className="px-6 py-3 rounded-full bg-white/15 text-white font-medium text-sm hover:bg-white/25 transition-colors whitespace-nowrap cursor-pointer no-underline backdrop-blur-sm"
                  >
                    了解我们
                  </Link>
                </div>
              </div>
            </div>
          </section>

          {/* Category Navigation */}
          <section className="py-14 md:py-20 bg-background-50">
            <div className="w-full px-4 md:px-6">
              <div className="max-w-7xl mx-auto">
                <div className="text-center mb-12">
                  <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
                    探索爱妻指南
                  </h2>
                  <p className="text-foreground-600 text-sm md:text-base max-w-lg mx-auto">
                    从多个维度提升你的"爱妻力"，选择你感兴趣的主题开始学习
                  </p>
                </div>
                <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
                  {categories.map((cat) => (
                    <Link
                      key={cat.id}
                      to={`/category/${cat.slug}`}
                      className="group bg-background-100 rounded-xl p-5 text-center hover:bg-primary-50 transition-all duration-300 cursor-pointer no-underline border border-transparent hover:border-primary-200"
                    >
                      <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-xl bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300">
                        <i className={`${cat.icon} text-xl`}></i>
                      </div>
                      <h3 className="font-heading text-sm font-semibold text-foreground-900 mb-1 whitespace-nowrap">
                        {cat.name}
                      </h3>
                      <p className="text-xs text-foreground-500 line-clamp-2 leading-relaxed">
                        {cat.description}
                      </p>
                    </Link>
                  ))}
                </div>
              </div>
            </div>
          </section>

          {/* Featured Articles */}
          <section className="py-14 md:py-20 bg-background-100">
            <div className="w-full px-4 md:px-6">
              <div className="max-w-7xl mx-auto">
                <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between mb-10 gap-4">
                  <div>
                    <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-2">
                      精选推荐
                    </h2>
                    <p className="text-sm text-foreground-600">
                      编辑精选的高质量婚姻经营文章
                    </p>
                  </div>
                  <Link
                    to="/category/langman-yishi"
                    className="text-sm text-primary-600 hover:text-primary-700 font-medium flex items-center gap-1 whitespace-nowrap cursor-pointer no-underline"
                  >
                    查看全部
                    <i className="ri-arrow-right-line"></i>
                  </Link>
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
                  {featuredArticles.map((article) => (
                    <ArticleCard
                      key={article.id}
                      slug={article.slug}
                      title={article.title}
                      excerpt={article.excerpt}
                      coverImage={article.coverImage}
                      categoryName={article.categoryName}
                      categorySlug={article.categorySlug}
                      author={article.author}
                      publishedAt={article.publishedAt}
                      readTime={article.readTime}
                    />
                  ))}
                </div>
              </div>
            </div>
          </section>

          {/* Latest Articles */}
          <section className="py-14 md:py-20 bg-background-50">
            <div className="w-full px-4 md:px-6">
              <div className="max-w-7xl mx-auto">
                <div className="text-center mb-12">
                  <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
                    最新文章
                  </h2>
                  <p className="text-sm text-foreground-600 max-w-lg mx-auto">
                    持续更新的婚姻幸福指南，不错过每一个提升感情的机会
                  </p>
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
                  {latestArticles.map((article) => (
                    <ArticleCard
                      key={article.id}
                      slug={article.slug}
                      title={article.title}
                      excerpt={article.excerpt}
                      coverImage={article.coverImage}
                      categoryName={article.categoryName}
                      categorySlug={article.categorySlug}
                      author={article.author}
                      publishedAt={article.publishedAt}
                      readTime={article.readTime}
                    />
                  ))}
                </div>
              </div>
            </div>
          </section>

          {/* CTA Section */}
          <section className="py-16 md:py-24 relative overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=A%20warm%20and%20romantic%20abstract%20background%20with%20soft%20coral%20and%20rose%20gradients%2C%20gentle%20flowing%20curves%2C%20dreamy%20bokeh%20effect%2C%20elegant%20and%20minimal%20composition%2C%20warm%20golden%20undertones&width=1600&height=600&seq=cta-bg-home&orientation=landscape"
              alt=""
              className="absolute inset-0 w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-background-900/60"></div>
            <div className="relative z-10 w-full px-4 md:px-6 text-center">
              <div className="max-w-2xl mx-auto">
                <h2 className="font-heading text-2xl md:text-3xl font-bold text-white mb-4">
                  准备好让你们的婚姻更幸福了吗？
                </h2>
                <p className="text-white/80 text-sm md:text-base mb-8 max-w-md mx-auto">
                  从今天开始，用爱和智慧经营你的婚姻。订阅爱妻艺，获取最新的婚姻幸福指南。
                </p>
                <Link
                  to="/category/fuqi-guanxi"
                  className="inline-flex px-6 py-3 rounded-full bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer no-underline"
                >
                  开始学习
                  <i className="ri-arrow-right-line ml-2"></i>
                </Link>
              </div>
            </div>
          </section>
        </main>

        <Footer />
      </div>
    </>
  );
}